import React from 'react';
import { useForm, Controller } from 'react-hook-form';

import { useTranslation } from 'hooks';
import { ArrivalTimeSelects, Button } from 'Profile/components';
import { formatArrivalTime } from 'utils/utils';

export default function ChangeETA({
	arrivalTimeValue,
	startDate,
	changeArrivalTime,
	goBackHandler,
}) {
	const { t } = useTranslation();

	const checkInTimeFormatted = formatArrivalTime(arrivalTimeValue);

	const { handleSubmit, control } = useForm({
		defaultValues: {
			arrivalTime: arrivalTimeValue,
		},
	});

	const onSubmit = ({ arrivalTime }) => {
		if (arrivalTime !== arrivalTimeValue) {
			changeArrivalTime({
				arrivalTime: `${arrivalTime} ${startDate}`,
			});
		} else {
			goBackHandler();
		}
	};

	return (
		<div className="change-detail-modal">
			<div className="change-detail-modal__header">
				<div className="change-detail-modal__title">{t('Arrival Time')}</div>
				<p className="change-detail-modal__copy">
					{t('To prepare your room, what is your estimated time of arrival?')}
				</p>
			</div>
			<form onSubmit={handleSubmit(onSubmit)} className="form-gray change-detail-modal__form">
				<Controller
					name="arrivalTime"
					control={control}
					as={ArrivalTimeSelects}
					labelAll={[t('Hour'), t('Min'), t('AM/PM')]}
					disabled={false}
					rules={{ required: true }}
				/>
				<Button
					type="submit"
					className="CTA--secondary--dark"
					aria-label={t('Set {0} arrival time', [checkInTimeFormatted])}
				>
					{t('Update')}
				</Button>
			</form>
		</div>
	);
}
